<template>
  <fragment>
    <edit-user-modal
      :is-editing-user="isEditingUser"
      :user-id="userId"
      @close="closeEditUserModal"
    ></edit-user-modal>
    <mc-app-header
      title="Users"
      has-search
      resource-state="users"
    ></mc-app-header>
    <mc-app-body>
      <div class="users section">
        <mc-paginated-list
          v-slot="{ items: usersList }"
          resource-state="users"
          has-search
        >
          <div v-if="usersList.length === 0" class="box mc-container">
            <div class="content has-text-centered">
              No users available!
            </div>
          </div>
          <div v-else class="mc-container">
            <div
              v-for="user in usersList"
              :key="user.id"
              class="users__item box"
            >
              <div class="users__item-details">
                <div class="users__item-title">
                  {{ displayDetails(user) }}
                </div>
              </div>
              <button class="button is-small" @click="editUserHandler(user.id)">
                Edit
              </button>
              <router-link
                class="button is-link is-small"
                :to="`/users/${user.id}/classes`"
              >
                Classes
              </router-link>
              <router-link
                class="button is-link is-small"
                :to="`/users/${user.id}/daily_challenges`"
              >
                Daily Challenges
              </router-link>
            </div>
          </div>
        </mc-paginated-list>
      </div>
    </mc-app-body>
  </fragment>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { displayDetails } from '../../utils/user';
import EditUserModal from '../../ui/modals/EditUserModal';
import con from '../../store/mutationTypes';
import users from '../../firebase/users.js';

export default {
  data() {
    return {
      isEditingUser: false,
      userId: ''
    };
  },
  components: {
    EditUserModal
  },
  methods: {
    ...mapActions('users', ['selectUser']),
    displayDetails,
    closeEditUserModal() {
      this.isEditingUser = false;
    },
    openEditUserModal() {
      this.isEditingUser = true;
    },
    editUserHandler(userId) {
      this.selectUser(userId);
      this.openEditUserModal();
    }
  }
};
</script>

<style lang="scss" scoped>
.users {
  height: 100%;

  &__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    &:not(.option) {
      padding: 1rem;
      margin-bottom: 0.5rem;
    }
  }

  &__item-details {
    flex: 1 0 0;
    flex-direction: column;
    margin-right: 0.5rem;
  }

  &__item-title {
    &--spacing {
      margin-bottom: 0.5rem;
    }
  }
}
.button:not(:last-child) {
  margin-right: 0.5rem;
}
</style>
